"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecentlyUsedTemplateIds = void 0;
var _react = require("react");
var _useLocalStorage = require("../../hooks/useLocalStorage");
var _issueTemplates = require("../../state/redux/ducks/issueTemplates");
var _hooks = require("../../state/redux/hooks");
var _currentUserPermissions = require("../../state/redux/ducks/currentUserPermissions");
const RECENTLY_USED_TEMPLATES_COUNT = 3;
const useRecentlyUsedTemplateIds = _ref => {
  let {
    selectedTemplateId
  } = _ref;
  const [getRecentlyUsedTemplateIds, setRecentlyUsedTemplateIds] = (0, _useLocalStorage.useLocalStorage)(_useLocalStorage.LocalStorageKeys.LAST_SELECTED_TEMPLATE_IDS);
  const recentlyUsedTemplateIds = (0, _react.useMemo)(() => {
    return getRecentlyUsedTemplateIds() || [];
  }, [getRecentlyUsedTemplateIds]);
  if (selectedTemplateId && !recentlyUsedTemplateIds.includes(selectedTemplateId)) {
    recentlyUsedTemplateIds.unshift(selectedTemplateId);
  }
  const onSelectTemplateIdCacheKey = JSON.stringify(recentlyUsedTemplateIds);
  const getTemplateById = (0, _hooks.useSelector)(_issueTemplates.getFnForGetIssueTemplateById);
  const currentUserPermittedStatusesForNewIssue = (0, _hooks.useSelector)(_currentUserPermissions.getCurrentUserPermittedStatusesForNewIssue);
  const getIsTemplateActive = (0, _hooks.useSelector)(_issueTemplates.getFnForIsTemplateActive);
  const recentlyUsedTemplatesToDisplay = (0, _react.useMemo)(() => {
    return recentlyUsedTemplateIds.map(templateId => {
      const template = getTemplateById(templateId);
      if (!template) {
        return null;
      }
      const isTemplateActive = getIsTemplateActive(template);
      if (!isTemplateActive) {
        return null;
      }
      const isTemplateStatusActive = (0, _issueTemplates.getIsTemplateStatusActive)({
        template,
        currentUserPermittedStatusesForNewIssue
      });
      if (!isTemplateStatusActive) {
        return null;
      }
      return template;
    }).filter(x => !!x);
  }, [currentUserPermittedStatusesForNewIssue, getIsTemplateActive, getTemplateById, recentlyUsedTemplateIds]);
  const addTemplateIdToRecentlyUsed = (0, _react.useCallback)(templateId => {
    let newRecentlyUsedTemplateIds = recentlyUsedTemplateIds.filter(recentlyUsedTemplateId => recentlyUsedTemplateId !== templateId);
    newRecentlyUsedTemplateIds.unshift(templateId);
    newRecentlyUsedTemplateIds = newRecentlyUsedTemplateIds.slice(0, RECENTLY_USED_TEMPLATES_COUNT);
    setRecentlyUsedTemplateIds(newRecentlyUsedTemplateIds);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [onSelectTemplateIdCacheKey, setRecentlyUsedTemplateIds]);
  return {
    recentlyUsedTemplateIds,
    recentlyUsedTemplatesToDisplay,
    addTemplateIdToRecentlyUsed
  };
};
exports.useRecentlyUsedTemplateIds = useRecentlyUsedTemplateIds;
//# sourceMappingURL=useRecentlyUsedTemplateIds.js.map